import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import QuoteAddLayer from "../components/QuoteAddLayer";




const QuoteAddPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Quote - Add" />

        {/* InvoiceAddLayer */}
        <QuoteAddLayer />

      </MasterLayout>

    </>
  );
};

export default QuoteAddPage;
